import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useParams } from 'react-router';
import { MessagePageProps, MessagePageType } from './models';
import { TechnicalErrorContent } from './components/technicalErrorContent/TechnicalErrorContent';
import { SessionExpiredContent } from './components/sessionExpiredContent/SessionExpiredContent';
import { InvalidLinkContent } from './components/invalidLinkContent/InvalidLinkContent';
import { SunbitSignature } from '@sunbit-dev/purchase-common/src/components/sunbitSignature/SunbitSignature';
import { PrivacyAllowanceLayer } from '@sunbit-dev/purchase-common/src/components/privacyAllowanceLayer/PrivacyAllowanceLayer';
import styled from 'styled-components';
import * as styles from './styles';
import URLs, { MessageURLs } from '~/enums/URLs';

export const MessagePage = styled(({ className }: MessagePageProps) => {
  const { type } = useParams<{ type: MessagePageType }>();
  const showSunbitTrademark = type !== MessagePageType.TechnicalError;

  return (
    <PrivacyAllowanceLayer>
      <div className={className}>
        <Switch>
          <Route path={URLs.Message + MessageURLs.InvalidLink} render={() => <InvalidLinkContent />} exact />
          <Route path={URLs.Message + MessageURLs.SessionExpiredByUI} render={() => <SessionExpiredContent />} exact />
          <Route path={URLs.Message + MessageURLs.TechnicalError} render={() => <TechnicalErrorContent />} exact />
        </Switch>
        {showSunbitTrademark && <SunbitSignature isContrastBackground />}
      </div>
    </PrivacyAllowanceLayer>
  );
})`
  ${styles.MessagePage}
`;
